export default "__VITE_ASSET__P3aM56Je__"